import type { ReactElement, SVGProps } from 'react';

import type { IconSVGProps } from './types';

/**
 * FinishIcon: ícono del paso de finalización.
 */
export const FinishIcon = ({
  className,
  width = 17,
  height = 17,
  ...props
}: IconSVGProps): ReactElement<SVGProps<SVGSVGElement>> => {
  return (
    <svg
      viewBox="0 0 17 17"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      aria-hidden
      focusable="false"
      {...props}
    >
      <g clipPath="url(#clip0_5707_4918)">
        <path
          d="M12.9506 6.89998H9.15057V8.29998C9.15057 9.29248 8.34307 10.1 7.35057 10.1C6.35807 10.1 5.55057 9.29248 5.55057 8.29998V5.25998L3.92807 6.23498C3.44557 6.52248 3.15057 7.04498 3.15057 7.60498V8.78748L1.15057 9.94248C0.76807 10.1625 0.63557 10.6525 0.85807 11.035L2.85807 14.5C3.07807 14.8825 3.56807 15.0125 3.95057 14.7925L6.53557 13.3H9.95057C10.8331 13.3 11.5506 12.5825 11.5506 11.7H11.9506C12.3931 11.7 12.7506 11.3425 12.7506 10.9V9.29998H12.9506C13.2831 9.29998 13.5506 9.03248 13.5506 8.69998V7.49998C13.5506 7.16748 13.2831 6.89998 12.9506 6.89998ZM16.6431 5.96498L14.6431 2.49998C14.4231 2.11748 13.9331 1.98748 13.5506 2.20748L10.9656 3.69998H8.41057C8.11057 3.69998 7.81807 3.78498 7.56307 3.94248L6.72557 4.46498C6.49057 4.60998 6.35057 4.86748 6.35057 5.14248V8.29998C6.35057 8.85248 6.79807 9.29998 7.35057 9.29998C7.90307 9.29998 8.35057 8.85248 8.35057 8.29998V6.09998H12.9506C13.7231 6.09998 14.3506 6.72748 14.3506 7.49998V8.21248L16.3506 7.05748C16.7331 6.83498 16.8631 6.34748 16.6431 5.96498Z"
          fill="inherit"
        />
      </g>
      <defs>
        <clipPath id="clip0_5707_4918">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.75 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
